<template>
  <div class="button-container">
    <v-btn
      text
      color="addButtonText"
      class="text-capitalize"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <v-icon left color="success" :size="iconSize" class="mr-1">{{ icon }}</v-icon>
      <div
        :class="{
          'small-font-size': smallFont,
          'add-button-text': !smallFont,
          'mobile-font-size': !smallFont && $vuetify.breakpoint.smAndDown,
          'desktop-font-size': !smallFont && $vuetify.breakpoint.mdAndUp
        }"
      >
        {{ text }}
      </div>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ButtonAdd',
  props: {
    text: {
      type: String,
      default: 'Add',
    },
    icon: {
      type: String,
      default: 'mdi-plus-circle',
    },
    smallFont: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconSize() {
      if (this.smallFont) {
        return 18;
      }

      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 24;
        case 'md':
        case 'lg':
        default:
          return 21;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.v-btn::before {
  background-color: transparent;
}
.add-button-text {
  letter-spacing: 0;
}
.button-container {
  display: inline-flex;
}

.small-font-size {
  font-size: 12px;
}

.mobile-font-size {
  font-size: 15px;
}

.desktop-font-size {
  font-size: 14px;
}

.v-btn:hover {
  background-color: var(--v-addButtonHover-base);
}

.v-btn:active {
  background-color: var(--v-addButtonActive-base);
}
</style>